import tingle from 'tingle.js';

export default function () {
  const modalTrigger = document.querySelectorAll('.js-generic-modal-trigger');

  if (!modalTrigger) {
    return;
  }

  [].forEach.call(modalTrigger, (function (element) {
    const packageName = element.getAttribute('data-package');
    const id = element.getAttribute('data-template-id');
    const template = document.querySelector(`.js-generic-modal-template[data-template-id="${id}"]`);

    element.addEventListener('click', function () {
      const modal = new tingle.modal({
        closeMethods: ['overlay', 'escape'],
        cssClass: ['modal'],
        onClose: function() {
          modal.destroy();
        },
      });

      modal.setContent(template.innerHTML.replace('{package}', packageName));
      modal.open();

      modal.modal.querySelector('.js-generic-modal-close').addEventListener('click', function () {
        modal.close();
      });
    });
  }));
};
